.alert {
  border-left: 4px solid gray;
  background-color: var(--base-white);
  padding: 2rem 2rem 2rem 5rem;
  position: relative;
  display: flex;
  gap: 1rem;

  > button {
    position: absolute;
    right: 2rem;
    top: 2rem;
  }
}

.inlineAlert {
  border: 1px solid;
  border-radius: var(--rounded-default);
  padding: 1.5rem;
  position: relative;

  svg {
    width: 1.5rem;
  }

  header {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  > button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
}

.alert,
.inlineAlert {
  a:not(:global(.button)):visited {
    color: var(--interactive-default);
  }

  aside {
    padding-top: 0.125rem;
    svg {
      width: 1.5rem;
    }
  }

  section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-width: 45rem;
    word-break: break-word;
    color: var(--base-black);

    p {
      margin: 0;
      max-width: 40rem;
      color: var(--base-black);
    }

    > ul {
      margin: 0;
      max-width: 40rem;
    }

    button {
      width: fit-content;
    }
  }

  &.error {
    border-color: var(--color-error-darker);
    background-color: var(--color-error-bg);
    > button:focus,
    > button:focus-visible {
      background: var(--base-white);
      border-color: var(--border-color-focus);
    }
    > button:hover {
      background: var(--color-error-hover);
    }
    aside > svg {
      fill: var(--color-error-darker);
    }
  }
  &.warning {
    border-color: var(--color-warning-darker);
    background-color: var(--color-warning-bg);
    > button:focus,
    > button:focus-visible {
      background: var(--base-white);
      border-color: var(--border-color-focus);
    }
    > button:hover {
      background: var(--color-warning-hover);
    }
    aside > svg {
      fill: var(--color-warning-darker);
    }
  }
  &.notify {
    border-color: var(--color-notify);
    background-color: var(--color-notify-bg);
    > button:focus,
    > button:focus-visible {
      background: var(--base-white);
      border-color: var(--border-color-focus);
    }
    > button:hover {
      background: var(--color-notify-hover);
    }
    aside > svg {
      fill: var(--color-notify);
    }
  }
  &.success {
    border-color: var(--color-success);
    background-color: var(--color-success-bg);
    > button:focus,
    > button:focus-visible {
      background: var(--base-white);
      border-color: var(--border-color-focus);
    }
    > button:hover {
      background: var(--color-success-hover);
    }
    aside > svg {
      fill: var(--color-success);
    }
  }

  &:global(.small) {
    padding: 1rem 1.5rem;
    align-items: center;
    max-width: 51rem;
    width: fit-content;

    aside {
      display: flex;
      padding: 0;
    }
    section {
      gap: 10px;
    }
  }

  &:global(.no-icon) {
    padding: 2rem 2.5rem;

    &:global(.small) {
      padding: 1rem 1.5rem;
    }
  }
}
